import { ProductShopItemConfig } from '~/shared';
import { createSlice } from '../wrappers';

interface ProductShopSlice {
	activeIndex: number | null;
	activeItem: ProductShopItemConfig | null;
	maxIndex: number;
	count: number;
	activeTab: number;
}

const initialState: ProductShopSlice = {
	activeIndex: null,
	activeItem: null,
	maxIndex: 0,
	count: 0,
	activeTab: 0,
};

const productShopSlice = createSlice({
	name: 'productShop',
	initialState,
	reducers: {
		setActiveIndex: (state, action) => {
			state.activeIndex = action.payload;
		},
		setActiveItem: (state, action) => {
			state.activeItem = action.payload;
		},
		setMaxIndex: (state, action) => {
			state.maxIndex = action.payload;
		},
		setCount: (state, action) => {
			state.count = action.payload;
		},
		setActiveTab: (state, action) => {
			state.activeTab = action.payload;
		},
	},
});

export const {
	setActiveIndex,
	setActiveItem,
	setMaxIndex,
	setCount,
	setActiveTab,
} = productShopSlice.actions;

export default productShopSlice.reducer;
